import { FC } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import useStore from '@hooks/useStore';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import CopyToClipboard from '@components/CopyToClipboard';

import { ReactComponent as CopyIcon } from '@assets/images/icons/copy.svg';

import useStyles from './styles';
import handleRedirect from '@utils/handleRedirect';

const OysterSpeiInfo: FC = () => {
  const {
    links,
    links: {
      coBrandingConfig: { primaryColor },
    },
    checkout,
  } = useStore();
  const css = useStyles({ primaryColor });
  const { t } = useTranslation();

  const accountInfo = [
    {
      key: 'account-info-business',
      label: t('checkoutScreen.payment.spei.businessName'),
      value: links.accountInfo.businessName,
    },
    {
      key: 'account-info-clabe',
      label: t('checkoutScreen.payment.spei.clabe'),
      value: links.accountInfo.clabe,
      formattedValue: links.accountInfo.clabe.replace(/(.{4})(.{4})(.{4})(.+)/g, '$1 $2 $3 $4'),
    },
    {
      key: 'account-info-concept',
      label: t('checkoutScreen.payment.spei.concept'),
      value: links.paymentLink.title,
    },
    {
      key: 'account-info-bank-name',
      label: t('checkoutScreen.payment.spei.bank'),
      value: links.accountInfo.bankName,
    },
  ];

  const clickContinueHandler = () => handleRedirect();

  return (
    <div className={css.root} data-testid="spei-info">
      <div className={css.accountInfo}>
        {accountInfo.map((accountInfoItem) => {
          const accountInfoItemValue = accountInfoItem.formattedValue || accountInfoItem.value;
          return (
            <Box
              display="flex"
              key={accountInfoItem.key}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box>
                <div className={css.label}>{accountInfoItem.label}</div>
                <div className={css.value}>{accountInfoItemValue}</div>
              </Box>
              <Box>
                <IconButton className={css.copyIcon}>
                  <CopyToClipboard
                    tooltipText={t('checkoutScreen.payment.spei.copied')}
                    text={accountInfoItem.value}
                  >
                    <SvgIcon component={CopyIcon} />
                  </CopyToClipboard>
                </IconButton>
              </Box>
            </Box>
          );
        })}
      </div>
      {checkout.hasRedirectionUrl && (
        <Button
          data-testid="continue-button"
          onClick={clickContinueHandler}
          className={css.continueButton}
          fullWidth
          color="primary"
        >
          {t('checkoutScreen.payment.success.goBack')}
        </Button>
      )}
    </div>
  );
};

export default observer(OysterSpeiInfo);
